import { Container, Row, Col } from "react-bootstrap";
import { MailchimpForm } from "./MailchimpForm";
import logo from "../assets/img/IndustriasBlader.png";
import navIcon1 from "../assets/img/nav-icon1.svg";
import navIcon2 from "../assets/img/nav-icon2.svg";
import navIcon3 from "../assets/img/git.svg";
import behance from "../assets/img/bihance.svg";

export const Footer = () => {
  const currentYear = new Date().getFullYear();
  return (
    <footer className="footer">
      <Container>
        <Row className="align-items-center">
          <MailchimpForm />
          <Col size={12} sm={6}>
            <img src={logo} alt="Logo" />
          </Col>
          <Col size={12} sm={6} className="text-center text-sm-end">
            <div className="social-icon">
              <a href="https://www.linkedin.com/in/cristian-extiven-valencia-22076a81/">
                <img src={navIcon1} alt="" />
              </a>
              <a href="https://github.com/Blader-1">
                <img src={navIcon3} alt="" />
              </a>
              <a href="https://www.behance.net/Blader">
                <img src={behance} alt="" />
              </a>
            </div>
            <p>
              &copy; {currentYear} Cristian Extiven Valencia Pino. Todos los
              derechos reservados.
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};
